import { DoctorTypeConstants } from "../types/DoctorTypeConstants";
let initialState = {
  allDoctorList: [],
  profile: {},
  searchResult: [],
  appointmentList : [],
};
export function doctor(state = initialState, action) {
  switch (action.type) {
    case DoctorTypeConstants.GET_ALL_DOCTOR_SUCCESS: {
      state.allDoctorList = action.data;
      state.profile ={};
      return state;
    }
    case DoctorTypeConstants.GET_DOCTOR_BY_ID_SUCCESS: {
      state.profile = action.data;
      return state;
    }
    case DoctorTypeConstants.SEARCH_DOCTOR_SUCCESS: {
      state.searchResult = action.data;
      return state;
    }
    case DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_SUCCESS: {
      state.searchResult = action.data;
      return state;
    }
    case DoctorTypeConstants.DOCTOR_APPOINTMENT_SUCCESS: {
      state.appointmentList = action.data;
      return state;
    }
    case DoctorTypeConstants.GET_DOCTOR_BY_ID_REQUEST: {
      state.profile ={};
      return state;
    }
    case DoctorTypeConstants.CLEAR_DOCTOR_SEARCH_RESULT: {
      state.searchResult = [];
      return state;
    }
    default:
      return state;
  }
}
